export default {"src":"/_next/static/media/pt.fd95bfef.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};